import styled from 'styled-components'

export const SmallTitle = styled.h1 `
    font-size: 1.6rem;
    color: #da6c36;
    font-family: 'Nerko One', cursive;
    letter-spacing: 0.2rem;

`

export const StyledTitle = styled(SmallTitle) `
    :after {
        background-color: #da6c36;
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 50%;
    }

    :before {
        right: 0.5em;
        margin-left: -50%;
    }

    :after {
        left: 0.5em;
        margin-right: -50%;
    }
`

export const StyledTitleRight = styled(SmallTitle) `
    :before {
        background-color: #da6c36;
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 50%;
    }

    :before {
        right: 0.5em;
        margin-left: -50%;
    }
`

export const IntroText = styled.p `
    font-size: 1.2rem;
    color: #a7a2a2;
    line-height: 1.6rem;
    margin-top: 3rem;
    max-width: 40rem;
`

export const Container = styled.div `
    @media (min-width: 480px){
        position: relative;
        margin-top: 16rem;
    }

    margin-left: 2rem;
    margin-top: 3rem;
    width: 100%;
    margin-bottom: 5rem;
    
`

export const ContainerFooter = styled(Container) `
    margin-bottom: 0;

`